<template>
    <v-card>
        <v-card-title>
            Issue Tags
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4">

            <div id="ag-grid-container">
                <ag-grid-vue style="width: 100%; height: 100%;" class="ag-theme-balham" v-if="showGrid"
                    :gridOptions="gridOptions"
                    @row-double-clicked="(params) => editIssueTag(params.data)"
                    :groupHeaders="true"
                    :rowHeight="40">
                </ag-grid-vue>
            </div>

            <v-btn class="mt-5" text @click="createNewIssueTag" :disabled="lockSave" v-if="showGrid"><v-icon small class="mr-1">mdi-plus-circle-outline</v-icon> Create New Issue Tag</v-btn>

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>


        <v-dialog v-model="showEditTag" max-width="80%" width="400px" persistent>
            <edit-issue-tag :editTagClone="editTagClone" :existingTags="issueTags" @save="save" @cancel="showEditTag = false; editTagClone = null;" v-if="showEditTag" />
        </v-dialog>

    </v-card>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "../../../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../../../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import EditIssueTag from "@/components/Issues/EditIssueTag";
export default {
    name: 'IssueTags',
    props: [],
    components: {
        'ag-grid-vue': AgGridVue,
        EditIssueTag
    },
    data: () => ({
        lockSave: false,
        issueTags: [],
        showGrid: false,
        gridOptions: null,
        showEditTag: false,
        editTagClone: null
    }),

    computed: {
    },

    methods: {
        getIssueTags: function() {
            this.showGrid = false;
            let route = (TELSA.apiHost + "issues/tags/list");
            TELSA.loading(true);
            return this.$http.get(route).then(response => {
                let result = response.body;
                this.issueTags = result;
                this.buildAgGrid();
                TELSA.loading(false);
            });
        },

        buildAgGrid: function() {
            this.showGrid = false;
            this.gridOptions = {};
            this.gridOptions.rowData = this.issueTags;
            this.gridOptions.columnDefs = this.createColumnDefs();
            let self = this;
            this.gridOptions.onGridReady = function(params) {
                self.gridOptions.api.hideOverlay();
                //self.gridOptions.columnApi.autoSizeColumns();
                self.gridOptions.api.sizeColumnsToFit();
            }

            this.gridOptions.getContextMenuItems = function() {
                return [
                    'copy',
                    'copyWithHeaders',
                    'paste',
                    'csvExport',
                    'excelExport'
                ];
            };

            this.gridOptions.defaultColDef = {
                sortable: true,
                filter: true,
                resizable: true
            }
            this.showGrid = true;
        },

        createColumnDefs: function() {
            let columnDefs = [];
            const self = this;
            columnDefs = [
                { 
                    headerName: '', 
                    suppressSizeToFit: true,
                    width: 90, filter: 'text', cellStyle: {'padding-top': '5px', 'text-align': 'left', 'background-color': 'white', 'border-right': 'black solid 1px'},
                    cellRenderer: class {
                        init(params) {
                            this.params = params;
                            this.eGui = document.createElement('div');
                            this.eGui.innerHTML = `<span class="mdi mdi-pencil-circle issue-tag-action" style="cursor: pointer; color: #c42111; font-size: 20pt" />
                                <span class="mdi mdi-delete-circle issue-tag-action" style="cursor: ${self.lockSave ? 'default' : 'pointer'}; color: ${self.lockSave ? '#E0E0E0' : '#c42111'}; font-size: 20pt" />`;
                            
                            this.editButtonHandler = this.editButtonHandler.bind(this);
                            this.deleteButtonHandler = this.deleteButtonHandler.bind(this);

                            this.editButton = this.eGui.querySelectorAll('.issue-tag-action')[0];
                            this.deleteButton = this.eGui.querySelectorAll('.issue-tag-action')[1];
                            this.editButton.addEventListener('click', this.editButtonHandler);
                            this.deleteButton.addEventListener('click', this.deleteButtonHandler);
                        }
                        getGui() {
                            return this.eGui;
                        }
                        editButtonHandler(event) {
                            event.stopPropagation();
                            this.params.editFunction(this.params);
                        }
                        deleteButtonHandler(event) {
                            event.stopPropagation();
                            this.params.deleteFunction(this.params);
                        }
                        destroy() {
                            this.editButton.removeEventListener('click', this.editButtonHandler);
                            this.deleteButton.removeEventListener('click', this.deleteButtonHandler);
                        }
                    },
                    cellRendererParams: {
                        editFunction: (params) => {
                            this.editIssueTag(params.data);
                            
                        },
                        deleteFunction: (params) => {
                            if(!self.lockSave) {
                                this.deleteIssueTagClick(params.data);
                            }
                        }
                    }
                },
                { 
                    headerName: 'Tag Name', 
                    field: 'issue_tag_name', 
                    width: 150, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'} 
                },
                { 
                    headerName: 'Description', 
                    field: 'issue_tag_desc', 
                    width: 300, filter: 'text', cellStyle: {'padding-top': '8px', 'text-align': 'left'},
                }
            ];
            return columnDefs;
        },

        createNewIssueTag: function() {
            this.editTagClone = {
                issue_tag_id: 0,
                issue_tag_name: '',
                issue_tag_desc: '',
            };
            this.showEditTag = true;
        },

        editIssueTag: function(issueTag) {
            this.editTagClone = JSON.parse(JSON.stringify(issueTag));
            this.showEditTag = true;
        },

        save: function() {
            let route = (TELSA.apiHost + "issues/tags/add");
            if(this.editTagClone.issue_tag_id) {
                route = (TELSA.apiHost + "issues/tags/edit");
            }
            TELSA.loading(true);
            this.$http.post(route, {args: {issueTag: this.editTagClone}}).then(response => {
                let result = response.body;
                this.showEditTag = false;
                this.editTagClone = null;
                this.getIssueTags();
                this.$emit('reload');
            });
        },

        deleteIssueTagClick: function(issueTag) {
            this.$store.commit('showConfirmModal', {
                title: 'Delete Issue Tag',
                message: `This operation will delete this issue tag and will be removed from any tickets it is assigned to. Are you sure you want to do this?`,
                type: 'delete',
                hideCancel: false,
                confirmAction: () => this.deleteIssueTag(issueTag)
            });
        },

        deleteIssueTag: function(issueTag) {
            let route = (TELSA.apiHost + "issues/tags/delete");
            TELSA.loading(true);
            this.$http.post(route, {args: {issueTagId: issueTag.issue_tag_id}}).then(response => {
                let result = response.body;
                this.getIssueTags();
                this.$emit('reload');
            });
        }
    },

    mounted() {
        // Permissions Check
        let permission = TELSA.checkPermission(this.$store.state.user, 'admin/issue/tags');
        if(!permission) {
            let self = this;
            this.$store.commit('insufficientPermissions', {
                confirmAction: function(){}
            });
            this.lockSave = true;
            return;
        }

        let lockName = `issue_tags`;
        this.$store.dispatch('getLock', lockName).then(lockOwner => {
            this.getIssueTags().then(v => {
                if(lockOwner) {
                    // Disable save and let user know page is locked!
                    this.lockSave = true;
                    this.$store.commit('showConfirmModal', {
                        title: 'Lock Warning',
                        message: `The Issue Tags are already locked for editing by <font color="#FB8C00"><b>${lockOwner}</b></font>. You cannot edit them at this time.`,
                        type: 'warning',
                        hideCancel: true,
                        confirmAction: function(){}
                    });
                }
            });
        });
    }


};
</script>

<style scoped>

    #ag-grid-container {
        /* height: calc(100vh - 126px); */
        height: 500px;
        width: 100%;
    }

</style>
